import getGatsbyPageData from '@/hooks/use-data/gatsby-page-data';

const useCities = () => {
  const queryData = getGatsbyPageData();
  const cities = queryData.cities.nodes;
  return { cities };
};

export default useCities;
